const ApplicationTypes = Object.freeze({
  ios: 'ios',
  android: 'android',
  web: 'web'
})

const ApplicationSubTypes = Object.freeze({
  huawei: 'huawei'
})

export { ApplicationTypes, ApplicationSubTypes }



// WEBPACK FOOTER //
// ./src/modules/account/enum/ApplicationEnum.js